import NsFormGroup from '@britishgasenergy/react-nucleus/dist/nuc-components/NsFormGroup';
import capitalize from 'lodash/capitalize';

import { NsMeterReadInput } from 'components/common/ns-meter-read-input/NsMeterReadInput';

type Register = {
  id: string | number;
  period?: string;
  digits?: string;
};

type FuelRegistersProps = {
  fuelType: 'electricity' | 'gas';
  registers: Register[];
  meterReads: object;
  onChange: () => void;
  defaultDigits: number;
};

export const FuelRegisters = ({
  fuelType,
  registers,
  meterReads,
  onChange,
  defaultDigits
}: FuelRegistersProps) => {
  return (
    <NsFormGroup legend={capitalize(fuelType)}>
      {registers?.map((register) => {
        const tempDigits = parseInt(register?.digits ?? '', 10);
        const { id, period } = register;
        const digits =
          !isNaN(tempDigits) && tempDigits ? tempDigits : Number(defaultDigits);
        const label = [capitalize(period || ''), 'Reading']
          .filter(Boolean)
          .join(' ');
        const stringId = `${id}`;
        return (
          <NsMeterReadInput
            id={stringId}
            key={id}
            label={label}
            name={stringId}
            value={meterReads[id]}
            digits={digits}
            onChange={onChange}
          />
        );
      })}
    </NsFormGroup>
  );
};
